import dayjs from "dayjs";

export const ltrim = (str) => {
  if (!str) return str;
  return str.replace(/^\s+/g, "");
};

export const convertToHHMM = (isoTimeString) => {
  const timeObject = dayjs(isoTimeString);
  return timeObject.format("HH:mm");
};

export const formatDateToYYYYMMDD = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};

export const formatToYYYY = (date) => {
  return dayjs(date).format("YYYY");
};

export const convertYYYYToDayJS = (year) => {
  const dateString = `${year}-01-01`;
  return dayjs(dateString);
};

export const generateRandomColor = (index) => {
  const colors = [
    "red",
    "green",
    "yellow",
    "orange",
    "purple",
    "cyan",
    "magenta",
    "pink",
    "brown",
    "violet",
    "indigo",
    "navy",
    "maroon",
    "black",
  ];

  return colors[index];
};
